// extracted by mini-css-extract-plugin
export default {"FilterSection":"FilterSection-module__FilterSection__qc5Ol"};